/**
 * The text for a failed Nextcloud integration call (#98): proxy codes with
 * their own text, forbidden, otherwise a generic "could not be reached".
 */

import { isIntegrationError } from '../core/integrations-service';
import { GatewayErrorCode, isGatewayError } from '../core/gateway/error-codes';

const K = 'modules.integrations.nextcloud.errors';

/** Proxy codes with their own text (`modules.integrations.nextcloud.errors.<code>`). */
export const NEXTCLOUD_ERROR_CODES: readonly string[] = [
  'INVALID_SERVER_URL',
  'NEXTCLOUD_UNSUPPORTED',
  'NEXTCLOUD_UNREACHABLE',
  'NEXTCLOUD_SERVER_MISMATCH',
  'ALREADY_CONNECTED',
  'RATE_LIMITED',
  'INVALID_STATE',
  'FOLDER_OVERLAP',
  'FOLDER_LIMIT',
  'NEEDS_RECONNECT',
];

export function nextcloudErrorText(
  error: unknown,
  t: (key: string) => string
): string {
  if (isIntegrationError(error) && NEXTCLOUD_ERROR_CODES.includes(error.code)) {
    return t(`${K}.${error.code}`);
  }
  if (isGatewayError(error) && error.code === GatewayErrorCode.FORBIDDEN) {
    return t(`${K}.forbidden`);
  }
  return t(`${K}.generic`);
}
